import React, {useState} from 'react';

const Boxes = (props) => {
    const {
        FeaturesAndBenefitsTitle,
        FeaturesAndBenefitsDescription,
        HowToUseTitle,
        HowToUseDescription
    } = props.product.Model;

    const [showFeaturesAndBenefits, setShowFeaturesAndBenefits] = useState(false);
    const [showHowToUse, setShowHowToUse] = useState(false);

    return (
        <div className="product-boxes">
            {FeaturesAndBenefitsTitle.Value !== "" && (
                <div className="product-box">
                    <div className={(showFeaturesAndBenefits ? "active " : "") + "product-box-title"} onClick={() => setShowFeaturesAndBenefits(!showFeaturesAndBenefits)}>
                        <h2>{FeaturesAndBenefitsTitle.Value}</h2>
                    </div>
                    {(!props.isMobile || showFeaturesAndBenefits) && (
                        <div className="product-box-content" dangerouslySetInnerHTML={{"__html": FeaturesAndBenefitsDescription.Value}} />
                    )}
                </div>
            )}
            {HowToUseTitle.Value !== "" && (
                <div className="product-box">
                    <div className={(showHowToUse ? "active " : "") + "product-box-title"} onClick={() => setShowHowToUse(!showHowToUse)}>
                        <h2>{HowToUseTitle.Value}</h2>
                    </div>
                    {(!props.isMobile || showHowToUse) && (
                        <div className="product-box-content" dangerouslySetInnerHTML={{"__html": HowToUseDescription.Value}} />
                    )}
                </div>
            )}
        </div>
    );
}
export default Boxes;
